import Color from 'color'
import { useState, useMemo } from 'react'
import { useTranslations } from 'next-intl'
import { GetStaticProps } from 'next'

import ColorPicker from '../components/color-picker'
import Header from '../components/layouts/header'
import { Seo } from '@/components/seo'

function ColorLuminancePage() {
  const [color, setColor] = useState(Color('#f6ad55'))
  const t = useTranslations('ColorLuminance')

  const luminosity = useMemo(() => color.luminosity(), [color])

  return (
    <div>
      <Seo
        title={t('pageTitle')}
        description={t('pageDescription')}
        thumbnail="https://devtool.tech/thumbnail/lumi.png"
        path="/color-lumi"
      />
      <div className="container px-4 m-auto md:px-16">
        <Header title={t('headerTitle')} />
      </div>
      <ColorPicker onChange={setColor} color={color} />
      <div className="mt-12 font-mono text-center">
        <div className="text-3xl">
          {luminosity}
        </div>
      </div>
    </div>
  )
}

export default ColorLuminancePage

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      messages: (await import(`../messages/${locale}.json`)).default
    }
  }
}
